import PropTypes from 'prop-types';
import PlanProp from './PlanProp';
import {
  LICENSE_TYPE,
  LICENSE_TYPES,
  PAYMENT_METHOD,
  PAYMENT_METHODS,
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_STATUSES,
} from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(LICENSE_TYPES).isRequired,
  interval: PropTypes.string.isRequired,
  plan: PropTypes.shape(PlanProp.propType),
  expirationDate: PropTypes.number,
  startDate: PropTypes.number,
  cancellationDate: PropTypes.number,
  lastPaymentDate: PropTypes.number,
  subscriptionStartDate: PropTypes.number,
  subscriptionEndDate: PropTypes.number,
  subscriptionPaymentStatus: PropTypes.oneOf(SUBSCRIPTION_STATUSES).isRequired,
  paymentMethodType: PropTypes.oneOf(PAYMENT_METHODS),
  paymentMethodId: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
};

const defaultProp = {
  _id: '',
  type: LICENSE_TYPE.FREE,
  interval: 'month',
  plan: null,
  expirationDate: null,
  startDate: null,
  cancellationDate: null,
  lastPaymentDate: null,
  subscriptionStartDate: null,
  subscriptionEndDate: null,
  subscriptionPaymentStatus: SUBSCRIPTION_STATUS.NONE,
  paymentMethodType: PAYMENT_METHOD.CREDIT_CARD,
  paymentMethodId: null,
  isActive: false,
};

export default { propType, defaultProp };
